export const PLUGEM_INJ_MSG = {
    request: 'plugem_adapter_request',
    response: 'plugem_adapter_response',
    subscription: 'plugem_adapter_subscription',
    event: 'plugem_adapter_event',
};